module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/event_planner/enquiry_declined-7e0e56116b886f8dea166c0cdbd9473d.png";